import { apiClient } from '@/utils/axios'

import type { BillingPlan } from '../types'

async function getPlans(): Promise<BillingPlan[]> {
  const res = await apiClient.get('billing/plans')

  return res.data
}

async function getPortalLink() {
  const res = await apiClient.post('billing/session/portal')

  return res.data
}

async function endTrialNow() {
  const res = await apiClient.get('billing/end-trial-now?redirect=false')

  return res.data
}

export const billingService = {
  getPlans,
  getPortalLink,
  endTrialNow,
}
